<template>
  <div
     v-fade-on-scroll="$_onScroll"
     v-nav-swipe="{ left: $_onSwipeLeft, right: $_onSwipeRight, up: $_scrollToMainAction }"
     class="global-navigation"
     @mouseover.self="updateMouseCursor('navigation')"
     @mouseout="updateMouseCursor('default')">

     <!-- <div
      class="global-navigation__buttons"
      :class="{ 'global-navigation__buttons--scrolled': scrolled }"
      @mouseover.native="updateMouseCursor('button')"
      @mouseout.native="updateMouseCursor('default')">
      <div
        class="global-navigation__left"
        v-show="prevRoute">
        <router-link
          :to="{ name: prevRoute }"
          @mouseover.native="updateMouseCursor('button')"
          @mouseout.native="updateMouseCursor('default')">
          <span>Prev</span>
        </router-link>
      </div>

      <div
        class="global-navigation__right"
        v-show="nextRoute">
        <router-link
          :to="{ name: nextRoute }"
          @mouseover.native="updateMouseCursor('button')"
          @mouseout.native="updateMouseCursor('default')">
          <span>Next</span>
        </router-link>
      </div>
    </div> -->

    <!-- <div
      class="global-navigation__scroll"
      :class="{ 'global-navigation__scroll--scrolled': scrolled }"
      @click="$_scrollToMainAction"
      @mouseover="updateMouseCursor('button')"
      @mouseout="updateMouseCursor('default')">
      <span class="cta--small">Scorri</span><span class="cta--large">Scorri verso il basso <img class="cta--large__ico" :src="require('@/assets/img/down-nav-ico.svg')" alt="Scorri" width="" height="" /></span>
    </div> -->

    <!-- <div
      class="global-navigation__anniversario"
      :class="{ 'global-navigation__anniversario--scrolled': scrolled }">
      <img src="../assets/img/logo-anniversario.svg" width="80" height="90" alt="Anniversario GBR Rossetto" />
    </div> -->

    <div
      v-show="$route.meta.position - 2 >= 0"
      class="global-navigation__slidenav"
      :class="{ 'global-navigation__slidenav--scrolled': scrolled }">
      <ul class="global-navigation__slidenav__whites">
        <div :class="`global-navigation__slidenav__whites__slide global-navigation__slidenav__whites__slide--${$route.meta.position - 2}`">
          <li
            v-for="(route, index) of navRoutes"
            :key="index"
            @click="$router.push({ name: $_getRouteNameByPosition(route.position) })">
            <span class="global-navigation__slidenav__whites__dot"></span>
            <span v-if="route.path !== activeRoutePath" :class="`route-name route-${index}`">{{ route.footerName }}</span>
          </li>
        </div>
      </ul>

      <div
        class="global-navigation__slidenav__buttons__slide__center-button"
        :class="{ 'global-navigation__slidenav__buttons__slide__center-button--active': activeButton }"></div>

      <ul
        class="global-navigation__slidenav__buttons"
        @click="$_scrollToMainAction"
        @mouseover="activeButton = true"
        @mouseout="activeButton = false">
        <div :class="`global-navigation__slidenav__buttons__slide global-navigation__slidenav__buttons__slide--${$route.meta.position}`">
          <li
            v-for="(route, index) of routes"
            :key="index">
            {{ route.navName }}
          </li>
        </div>
      </ul>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import routesList from '@/router/routesList'
import { mapMutations } from 'vuex'
import Hammer from 'hammerjs'

export default {
  data: () => ({
    scrolled: window.pageYOffset > 0,
    routes: routesList,
    activeButton: false
  }),
  computed: {
    activeRoutePath () {
      return this.$route.path
    },
    nextRoute: {
      get () {
        return _.head(_.keys(_.pickBy(routesList, route => route.position === this.$route.meta.position + 1)))
      }
    },
    prevRoute: {
      get () {
        return _.head(_.keys(_.pickBy(routesList, route => route.position === this.$route.meta.position - 1)))
      }
    },
    navRoutes: {
      get () {
        return _.filter(routesList, r => r.position > 0)
      }
    }
  },
  mounted () {
    window.addEventListener('keyup', this.$_keyAtion)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.$_keyAtion)
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_keyAtion ({ key }) {
      if (key === 'ArrowRight') return this.$router.push({ name: this.nextRoute })
      if (key === 'ArrowLeft') return this.$router.push({ name: this.prevRoute })
    },
    $_onSwipeLeft () {
      return this.$router.push({ name: this.nextRoute })
    },
    $_onSwipeRight () {
      return this.$router.push({ name: this.prevRoute })
    },
    $_swipeAction (direction) {
      if (direction === 'swipeup') return this.$_scrollToMainAction()
    },
    $_scrollToMainAction () {
      const mainAction = document.querySelector('.content-wrapper')
      if (mainAction === null) return

      mainAction.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      })
    },
    $_onScroll () {
      this.scrolled = window.pageYOffset > 0
    },
    $_getRouteNameByPosition (position) {
      return _.head(_.keys(_.pickBy(routesList, route => route.position === position)))
    }
  },
  directives: {
    'fade-on-scroll': {
      bind (el, binding) {
        window.addEventListener('scroll', binding.value)
      },
      unbind (el, binding) {
        window.removeEventListener('scroll', binding.value)
      }
    },
    'nav-swipe': {
      bind (el, binding) {
        const manager = new Hammer.Manager(el)
        const swipe = new Hammer.Swipe()
        manager.add(swipe)

        manager.on('swipeleft', binding.value.left)
        manager.on('swiperight', binding.value.right)
        manager.on('swipeup', binding.value.up)
      }
    }
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

$marginLeftRight: 6.25%;
$marginLeftRightDesktop: 3.25%;
$marginTopBottom: 6.25%;
$marginTopBottomDesktop: 3.25%;

$white: #f2f2f2;

li {
 position: relative;
}

.route-name {
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translate(-50%, 70%);
 font-weight: 600;
 color: $white;
 font-size: 1.2rem;
 text-transform: uppercase;
 white-space: nowrap;
 text-align: center;
 @include media("<large"){
  font-size: 0.9rem;
  transform: translate(-50%, 100%);
  }
}

.route-4 {
  margin-left: 30px;
  @media (max-width: 768px) {
  margin-left: 20px;
  }
}

.route-0 {
  margin-left: -30px;
  @media (max-width: 768px) {
  margin-left: -20px;
  }
}

.global-navigation__logo{
  position: fixed;
}

.global-navigation__slidenav {
  transition: opacity .3s ease-in-out;
}

.global-navigation__slidenav--scrolled {
  opacity: 0;
  pointer-events: none;
}

.global-navigation__slidenav__whites {
  $whiteSize: 12px;
  height: 55px;
  list-style: none;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  position: absolute;
  bottom: 6.25%;
  left: 50%;
  transform: translateX(-$whiteSize*2);

  @media (max-width: 768px) {
    transform: translateX(-35px);
  }
  $buttonWidth: 160px;
  $buttonWidthMobile: 115px;

  .global-navigation__slidenav__whites__slide {
    transition: transform .3s ease-in-out;
  }

  @for $i from 0 through 9 {
  .global-navigation__slidenav__whites__slide--#{$i} {
      transform: translateX($buttonWidth * $i * -1)
   }
  }

  @media (max-width: 768px) {
  @for $i from 0 through 9 {
      .global-navigation__slidenav__whites__slide--#{$i} {
        transform: translateX($buttonWidthMobile * $i * -1);
        }
    }
  }

  li {
    display: inline-block;

    .global-navigation__slidenav__whites__dot {
      display: inline-block;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      vertical-align: middle;
      position: relative;

      &::before {
        content: "";
        display: inline-block;
        width: $whiteSize * 3.5;
        height: $whiteSize * 3.5;
        border: 2px solid white;
        border-radius: 50%;
        vertical-align: middle;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%) scale(0);
        transition: transform .25s ease-in-out;
      }

      &::after {
        content: "";
        display: inline-block;
        width: $whiteSize;
        height: $whiteSize;
        border-radius: 50%;
        background: white;
        vertical-align: middle;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
      }

      &:hover {
        &::before {
          transform: translateX(-50%) translateY(-50%) scale(1);
        }
      }
    }

    &::before {
      content: "";
      display: inline-block;
      opacity: .25;
      vertical-align: middle;
      transform: translateZ(0);
      width: 60px;
      border-bottom: 2px solid #fff;
      @media (max-width: 768px) {
      width: 40px;
      }
    }

    &::after {
      content: "";
      display: inline-block;
      opacity: .25;
      vertical-align: middle;
      transform: translateZ(0);
      width: 60px;
      border-bottom: 2px solid #fff;
      @media (max-width: 768px) {
      width: 40px;
      }
    }

    &:first-child {
      &::before {
        display: none;
      }
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }
}

$buttonWidth: 220px;
$buttonWidthMobileCenter: 150px;

.global-navigation__slidenav__buttons__slide__center-button {
  background: white;
  border-radius: 50000px;
  line-height: 70px;
  width: $buttonWidth;
  height: 70px;
  position: absolute;
  bottom: 6.25%;
  transform-origin: 50% 50%;
  transition: transform .25s ease-in-out;
  left: 50%;
  transform: translateX(-50%) scale(1);
  @media (max-width: 768px) {
  width: $buttonWidthMobileCenter;
  transform: translateX(-50%);
  }
}

.global-navigation__slidenav__buttons__slide__center-button--active {
  transform: translateX(-50%) scale(1.1);
  @media (max-width: 768px) {
  transform: translateX(-50%);
  }
}

.global-navigation__slidenav__buttons {
  width: $buttonWidth;
  height: 70px;
  list-style: none;
  margin: 0;
  padding: 0;
  color: #0A2F74;
  white-space: nowrap;
  text-align: center;
  position: absolute;
  bottom: 6.25%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  .global-navigation__slidenav__buttons__slide {
    transition: transform .3s ease-in-out;
    position: absolute;
  }

  @for $i from 0 through 9 {
    .global-navigation__slidenav__buttons__slide--#{$i} {
      transform: translateX($buttonWidth * $i * -1)
    }
  }

  li {
    display: inline-block;
    width: $buttonWidth;
    height: 70px;
    font-weight: 600;
    font-size: 1.8rem;
    vertical-align: middle;
    line-height: 70px;
    @media (max-width: 768px) {
      font-size: 1.4rem;
    }
  }
}

.global-navigation {
  position: fixed;
  margin: auto;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) translateZ(0);
  z-index: 10;
  box-sizing: border-box;
  padding: $marginLeftRight;
}

/* @group Morph Transition */
.morph-burger-leave {
  min-height: 20px;
}

.morph-burger-leave-to {
  min-height: 2px;
}
.morph-burger-enter-active, .morph-burger-leave-active {
  transition: all .8s;
}
/* @end */

.global-navigation__menu__button__close{
  &::before, &::after{
    top: 50%;
  }
}

.global-navigation__buttons {
  position: absolute;
  transition: opacity .3s;

  right: $marginLeftRight;
  top: 50%;
  transform: translateY(-50%);

  @include media(">=large"){
    top: auto;
    bottom: 0;
    right: 0;
    transform: none;
  }

  div{
    width: 40px;
    height: 60px;
    a{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .global-navigation__left{
    background-image: url(../assets/img/prev-arrow-ico.svg);
    background-position: center center;
    background-repeat: no-repeat;
    @include media("<large"){
      border-bottom: 1px solid #E30045;
    }
  }
  .global-navigation__right{
    background-image: url(../assets/img/next-arrow-ico.svg);
    background-position: center center;
    background-repeat: no-repeat;
  }
  span{
    display: none
  }
  div + div{
    margin-top: 1px;
  }
  a{
    font-size: 1.6rem;
    color: $white;
    text-decoration: none;
  }
  @include media(">=large"){
    right: $marginLeftRightDesktop;
    bottom: $marginTopBottomDesktop;

    div{
      width: auto;
      height: auto;
      background-color: transparent;
    }
    .global-navigation__left, .global-navigation__right{
      display: inline-block;
      background-image: none;
    }
    span{
      display: inline-block;
    }
    div + div{
      margin-left: 1.5rem;
      margin-top: 0;
    }
  }
  @include media(">=xlarge"){
    a{
      font-size: 1.8rem;
    }
  }
}

.global-navigation__scroll{
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 50%;
  bottom: 0;
  height: 90px;
  width: 80px;
  margin-bottom: 6.25%;
  transform: translateX(-50%);
  font-size: 1.6rem;
  color: $white;
  transition: opacity .3s;

  .cta--large{
    display: none;
  }
  .cta--large__ico{
    margin-left: 1rem
  }
  @include media(">=large"){
    .cta--small{
      display: none;
    }
    .cta--large{
      display: inline-block;
    }
  }

  &:after{
    content: "";
    display: inline-block;
    height: 90px;
    width: 1px;
    margin-top: 1.5rem;
    margin-left: -2px;
    background: $white;

    @include media("<large"){
      transform-origin: top center;
      animation-name: scrollBar;
      animation-duration: 2s;
      animation-iteration-count: infinite;
    }

  }

  @keyframes scrollBar {
    from {transform: scaleY(0)}
    to {transform: scaleY(1)}
  }

  @include media(">=large"){
    flex-direction: row;
    transform: translateX(-50%) rotate(0);
    right: auto;
    left: 50%;
    top: auto;
    bottom: auto;
    width: auto;
    margin: 0;
    height: auto;
    bottom: $marginTopBottomDesktop;
    span{
      writing-mode: horizontal-tb;
    }
    &:after{
      display: none;
    }
  }
  @include media(">=xlarge"){
    font-size: 1.8rem;
  }
}

.global-navigation__scroll--scrolled, .global-navigation__buttons--scrolled, .global-navigation__anniversario--scrolled {
  opacity: 0;
}

.global-navigation__anniversario{

  position: absolute;
  z-index: 1;
  transition: opacity .3s;

  left: 0;
  bottom: 0;
  margin-bottom: $marginTopBottom;
  margin-left: $marginLeftRight;

  @include media(">=large"){
    margin-left: $marginLeftRightDesktop;
    bottom: $marginTopBottomDesktop;
    margin-bottom: 0;
  }
}

.global-navigation__anniversario img{
  @include media("<large"){
    width: auto;
    height: 90px;
    display: inherit;
  }
}

</style>
